export default (renderer, fonts = []) => {
    if (Array.isArray(fonts)) {
        fonts.forEach(({ name, files, options }) => {
            if (!name || typeof name !== 'string') {
                console.warn('Font has to have a string name.');
            } else if (!files || !Array.isArray(files)) {
                console.warn('The font files have to be an array of url.');
            } else {
                renderer.renderFont(name, files, options);
            }
        });
    } else {
        console.warn('Fonts has to be an array to be rendered.');
    }
};
